export default __webpack_public_path__ + "static/media/situation-coref-entity-span.c7d824db.gif";